// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { RequirePermission } from "@/components/shared/require-permission";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/permissions/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.iamPermissions}>
      <PermissionsPage />
    </RequirePermission>
  ),
});

function PermissionsPage() {
  const { t } = useTranslation("back-office");

  return (
    <div>
      <PageHeader title={t("permissions.title")} />
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <ShieldCheck className="h-12 w-12 text-muted-foreground mb-4" />
        <h2 className="text-lg font-medium text-muted-foreground">{t("permissions.title")}</h2>
        <p className="text-sm text-muted-foreground mt-1">Coming soon</p>
      </div>
    </div>
  );
}
